var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-chevron-down",
    transform: "translate(1607 -28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_972",
    "data-name": "Rectangle 972",
    width: 37,
    height: 37,
    transform: "translate(-1607 28)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chevron-sort-down",
    d: "M18.833,32.5l-8.708-8.708,1.742-1.742,6.967,6.967L25.8,22.05l1.742,1.742Z",
    transform: "translate(-1607.125 18.95)",
    fill: "#c1c1c1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default __webpack_public_path__ + "static/media/icon-chevron-down.e807fab4ad7a27c06eac4a8f2e704e84.svg";
export { ForwardRef as ReactComponent };